module.exports = __webpack_public_path__ + "img/file-pdf-icon.01378003.png";